import React, { useState, useEffect } from 'react'
import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state'
import Container from 'react-bootstrap/Container'
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'
import NavDropdown from 'react-bootstrap/NavDropdown'
import Offcanvas from 'react-bootstrap/Offcanvas'
import './Header.css'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { ThemeProvider, createTheme } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'
import QueryStatsIcon from '@mui/icons-material/QueryStats'
import BoltIcon from '@mui/icons-material/Bolt'
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter'
import GroupsIcon from '@mui/icons-material/Groups'
import ApiIcon from '@mui/icons-material/Api'
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium'
import HandshakeIcon from '@mui/icons-material/Handshake'
import { useContextData } from '../../../core/context/index'
import { deleteCookie } from '../../../core/helper/cookie'
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined'
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined'
import HeadsetMicOutlinedIcon from '@mui/icons-material/HeadsetMicOutlined'
import ArrowRightOutlinedIcon from '@mui/icons-material/ArrowRightOutlined'

const HeaderHome = ({ userLogin }) => {
  const { myProfile, setUserProfile } = useContextData()
  const navigate = useNavigate()
  const pathname = useLocation().pathname
  const [expanded, setExpanded] = useState(false)
  const [isScrolled, setIsScrolled] = useState(false)
  const [openDropdown, setOpenDropdown] = useState(null)
  const [borderDropdown, setBorderDropdown] = useState(null)
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])
  const handleDropdownToggle = (key, isOpen) => {
    if (isOpen) {
      setOpenDropdown(key)
      setBorderDropdown(null)
    } else {
      setOpenDropdown(null)
      setBorderDropdown(key)
    }
  }
  useEffect(() => {
    const handleClickOutside = () => {
      if (!openDropdown && borderDropdown) {
        setBorderDropdown(null)
      }
    }

    document.addEventListener('click', handleClickOutside)
    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [openDropdown, borderDropdown])
  const theme = createTheme({
    palette: {
      mode: 'dark',
    },
  })
  useEffect(() => {
    setExpanded(false)
    setOpenDropdown(null)
    setBorderDropdown(null)
  }, [pathname])
  const menuBar = (
    <ThemeProvider theme={theme}>
      <PopupState variant='popover' popupId='demo-popup-menu'>
        {(popupState) => (
          <React.Fragment>
            <Button
              variant='text'
              className='btn-user-home'
              sx={{ textTransform: 'none', color: 'white' }}
              {...bindTrigger(popupState)}
            >
              <span className='btn-font'>
                {myProfile && (
                  <>
                    {(() => {
                      const value =
                        myProfile?.firstname
                          ? myProfile.firstname
                          : myProfile?.email
                            ? myProfile.email
                            : myProfile?.phoneno || '';

                      return value.length > 10
                        ? value.slice(0, 7) + '...'
                        : value;
                    })()}{' '}
                  </>
                )}
              </span>{' '}
              <KeyboardArrowDownIcon sx={{ color: 'white' }} />
            </Button>
            <Menu
              {...bindMenu(popupState)}
              sx={{
                '& .MuiPaper-root': {
                  backgroundColor: 'background.paper',
                  backgroundImage: 'none',
                  color: 'text.primary',
                },
              }}
            >
              <MenuItem
                sx={{
                  fontSize: '0.938rem',
                  fontWeight: 600,
                  color: 'text.primary',
                }}
                onClick={() => {
                  popupState.close()
                  setExpanded(false)
                }}
                as={Link}
                to='/my/profile'
                className='text-decoration-none'
              >
                <img
                  src='/assets/UserHome.svg'
                  alt=''
                  className='img-fluid me-1 menu-icon'
                  width={22}
                />{' '}
                Profile
              </MenuItem>
              <MenuItem
                sx={{
                  fontSize: '0.938rem',
                  fontWeight: 600,
                  color: 'text.primary',
                }}
                onClick={() => {
                  popupState.close()
                  setExpanded(false)
                }}
                as={Link}
                to='/my/identification'
                className='text-decoration-none'
              >
                <img
                  src='/assets/LockLaminatedHome.svg'
                  alt=''
                  className='img-fluid me-1 menu-icon'
                  width={22}
                />
                Identification
              </MenuItem>
              <MenuItem
                sx={{
                  fontSize: '0.938rem',
                  fontWeight: 600,
                  color: 'text.primary',
                }}
                onClick={() => {
                  popupState.close()
                  setExpanded(false)
                }}
                className='text-decoration-none'
                as={Link}
                to='/my/payment'
              >
                <img
                  src='/assets/CreditCardHome.svg'
                  alt=''
                  className='img-fluid me-1 menu-icon'
                  width={22}
                />
                Payment
              </MenuItem>
              <MenuItem
                sx={{
                  fontSize: '0.938rem',
                  fontWeight: 600,
                  color: 'text.primary',
                }}
                onClick={() => {
                  popupState.close()
                  setExpanded(false)
                }}
                className='text-decoration-none'
                as={Link}
                to='/my/referral'
              >
                <img
                  src='/assets/UserGearHome.svg'
                  alt=''
                  className='img-fluid me-1 menu-icon'
                  width={22}
                />
                Referral
              </MenuItem>
              <MenuItem
                sx={{
                  fontSize: '0.938rem',
                  fontWeight: 600,
                  color: 'text.primary',
                }}
                onClick={() => {
                  popupState.close()
                  setExpanded(false)
                }}
                className='text-decoration-none'
                as={Link}
                to='/my/SpotTradeHistory'
              >
                <img
                  src='/assets/ClockCounterClockwiseHome.svg'
                  alt=''
                  className='img-fluid me-1 menu-icon'
                  width={22}
                />
                Trade history
              </MenuItem>
              <MenuItem
                sx={{
                  fontSize: '0.938rem',
                  fontWeight: 600,
                  color: 'text.primary',
                }}
                onClick={() => {
                  popupState.close()
                  setExpanded(false)
                }}
                className='text-decoration-none'
                as={Link}
                to='/my/wallet/history'
              >
                <img
                  src='/assets/ClockCounterClockwiseHome.svg'
                  alt=''
                  className='img-fluid me-1 menu-icon'
                  width={22}
                />
                Transactions
              </MenuItem>
              <MenuItem
                sx={{
                  fontSize: '0.938rem',
                  fontWeight: 600,
                  color: 'text.primary',
                }}
                onClick={() => {
                  popupState.close()
                  deleteCookie('userToken')
                  setUserProfile()
                  navigate('/login')
                }}
                className='text-decoration-none'
              >
                <img
                  src='/assets/SignOutHome.svg'
                  alt=''
                  className='img-fluid me-1 menu-icon'
                  width={22}
                />
                Logout
              </MenuItem>
            </Menu>
          </React.Fragment>
        )}
      </PopupState>
    </ThemeProvider>
  )

  return (
    <div
      style={(() => {
        const stickyRoutes = [
          '/',
          '/signal',
          '/usdt-otc-desk',
          '/sub-broker',
          '/career',
          '/learn-crypto',
          '/earn',
        ]
        const dashboardSticky = [
          '/my/wallet/history',
          '/my/SpotTradeHistory',
          '/my/referral',
          '/my/payment',
          '/my/identification',
          '/my/profile',
        ]
        const path = window.location.pathname
        const isSticky =
          stickyRoutes.includes(path) ||
          dashboardSticky.some((route) => path.startsWith(route))
        return isSticky
          ? {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 1000,
            transition: 'all 0.3s ease',
            backgroundColor: isScrolled
              ? 'rgba(14, 17, 22, 0.85)'
              : 'transparent',
            backdropFilter: isScrolled ? 'blur(12px)' : 'none',
            borderBottom: isScrolled
              ? '1px solid rgba(255,255,255,0.05)'
              : 'none',
          }
          : {
            transition: 'all 0.3s ease',
            background: '#0E1116',
            color: '#DADADA',
            borderBottom: '1px solid rgba(255, 255, 255, 0.42)',
          }
      })()}
    >
      <Navbar expand='lg' variant='dark' className='pt-4 px-2 px-md-4' expanded={expanded} onToggle={(next) => setExpanded(next)}>
        <Container fluid className='px-2'>
          <Navbar.Brand as={Link} to='/' className='d-flex align-items-center'>
            <img src='/logo.png' alt='Unitic' className='img-fluid img-size' />
          </Navbar.Brand>

          <Navbar.Toggle
            aria-controls='offcanvasNavbar-expand-lg'
            className='custom-toggle'
          />

          <Navbar.Offcanvas
            id='offcanvasNavbar-expand-lg'
            aria-labelledby='offcanvasNavbarLabel-expand-lg'
            placement='end'
            className='w-75'
            style={{ background: '#0E1116', color: '#DADADA' }}
            onHide={() => setExpanded(false)}
          >
            <Offcanvas.Header closeButton closeVariant='white'>
              <Offcanvas.Title id='offcanvasNavbarLabel-expand-lg'>
                <img
                  src='/logo.png'
                  alt='Unitic'
                  className='img-fluid img-size'
                />
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Nav className='me-auto align-items-start align-items-lg-center justify-content-center flex-grow-1 darkNavCss gap-nav'>
                <Nav.Link as={Link} to='/markets'>
                  <span
                    style={{
                      color: pathname.includes('/markets') ? '#1DA094' : '',
                    }}
                  >
                    Markets
                  </span>
                </Nav.Link>

                <NavDropdown
                  style={{ backgroundColor: 'transparent', marginLeft: '0px' }}
                  title={
                    <span
                      style={{
                        color:
                          pathname.includes('/spot-usdt/BTC-USDT') ||
                            pathname.includes('/futures/trade/BTCUSDT') ||
                            pathname.includes('/Insta-Trade')
                            ? '#1DA094'
                            : '',
                      }}
                      className='more-dropdown-title'
                    >
                      Trade
                    </span>
                  }
                  id='trade-dropdown'
                  menuVariant='dark'
                  show={openDropdown === 'trade'}
                  onToggle={(isOpen) => handleDropdownToggle('trade', isOpen)}
                  className={`custom-trade-nav-dropdown ${borderDropdown === 'trade' ? 'show-green-border' : ''
                    }`}
                >
                  <div className='dropdown-inner-wrapper' onClick={() => setExpanded(false)}>
                    <NavDropdown.Item
                      as={Link}
                      to='/spot-usdt/BTC-USDT'
                      className='dropdown-item-card'
                    >
                      <div className='item-wrapper'>
                        <span className='item-icon'>
                          <TrendingUpIcon fontSize='small' />
                        </span>

                        <span className='item-content'>
                          <span className='item-title'>Spot</span>
                          <span className='item-desc'>Low crypto fees</span>
                        </span>

                        <span className='item-arrow'>
                          <ArrowRightOutlinedIcon fontSize='small' />
                        </span>
                      </div>
                    </NavDropdown.Item>

                    <div className='dropdown-divider-custom' />

                    <NavDropdown.Item
                      as={Link}
                      to='/futures/trade/BTCUSDT'
                      className='dropdown-item-card'
                    >
                      <div className='item-wrapper'>
                        <span className='item-icon'>
                          <QueryStatsIcon fontSize='small' />
                        </span>

                        <span className='item-content'>
                          <span className='item-title'>Futures</span>
                          <span className='item-desc'>125x leverage</span>
                        </span>

                        <span className='item-arrow'>
                          <ArrowRightOutlinedIcon fontSize='small' />
                        </span>
                      </div>
                    </NavDropdown.Item>

                    <div className='dropdown-divider-custom' />

                    {/* <NavDropdown.Item
                      as={Link}
                      to='/Insta-Trade'
                      className='dropdown-item-card'
                    >
                      <div className='item-wrapper'>
                        <span className='item-icon'>
                          <BoltIcon fontSize='small' />
                        </span>

                        <span className='item-content'>
                          <span className='item-title'>Insta</span>
                          <span className='item-desc'>One-Click trade</span>
                        </span>

                        <span className='item-arrow'>
                          <ArrowRightOutlinedIcon fontSize='small' />
                        </span>
                      </div>
                    </NavDropdown.Item> */}
                  </div>
                </NavDropdown>

                <Nav.Link as={Link} to='/earn'>
                  <span
                    style={{
                      color: pathname.includes('/earn') ? '#1DA094' : '',
                    }}
                  >
                    Earn
                  </span>
                </Nav.Link>
                <Nav.Link as={Link} to='/learn-crypto'>
                  <span
                    style={{
                      color: pathname.includes('/learn-crypto') ? '#1DA094' : '',
                    }}
                  >
                    Learn
                  </span>
                </Nav.Link>
                <Nav.Link as={Link} to='/usdt-otc-desk'>
                  <span
                    style={{
                      color: pathname.includes('/usdt-otc-desk') ? '#1DA094' : '',
                    }}
                  >
                    OTC
                  </span>
                </Nav.Link>
                <Nav.Link as={Link} to='/signal'>
                  <span
                    style={{
                      color: pathname.includes('/signal') ? '#1DA094' : '',
                    }}
                  >
                    TradeIQ
                  </span>
                </Nav.Link>

                <NavDropdown
                  style={{ backgroundColor: 'transparent', marginLeft: '0px' }}
                  title={
                    <span
                      className='more-dropdown-title'
                      style={{
                        color:
                          pathname.includes('/usdt-otc-desk') ||
                            pathname.includes('/sub-broker') ||
                            pathname.includes('/api-docs') ||
                            pathname.includes('/vip-trading') ||
                            pathname.includes('/partnership')
                            ? '#1DA094'
                            : '',
                      }}
                    >
                      Institutional
                    </span>
                  }
                  id='institutional-dropdown'
                  menuVariant='dark'
                  show={openDropdown === 'institutional'}
                  onToggle={(isOpen) =>
                    handleDropdownToggle('institutional', isOpen)
                  }
                  className={`custom-trade-nav-dropdown ${borderDropdown === 'institutional'
                    ? 'show-green-border'
                    : ''
                    }`}
                >
                  <div className='dropdown-inner-wrapper' onClick={() => setExpanded(false)}>
                    <NavDropdown.Item
                      as={Link}
                      to='/usdt-otc-desk'
                      className='dropdown-item-card'
                    >
                      <div className='item-wrapper'>
                        <span className='item-icon'>
                          <BusinessCenterIcon fontSize='small' />
                        </span>
                        <span className='item-content'>
                          <span className='item-title'>OTC Trading Desk</span>
                          <span className='item-desc'>
                            Large volume execution
                          </span>
                        </span>
                        <span className='item-arrow'>
                          <ArrowRightOutlinedIcon fontSize='small' />
                        </span>
                      </div>
                    </NavDropdown.Item>
                    <div className='dropdown-divider-custom' />
                    <NavDropdown.Item
                      as={Link}
                      to='/sub-broker'
                      className='dropdown-item-card'
                    >
                      <div className='item-wrapper'>
                        <span className='item-icon'>
                          <GroupsIcon fontSize='small' />
                        </span>
                        <span className='item-content'>
                          <span className='item-title'>Sub broker Program</span>
                          <span className='item-desc'>
                            Partner network growth
                          </span>
                        </span>
                        <span className='item-arrow'>
                          <ArrowRightOutlinedIcon fontSize='small' />
                        </span>
                      </div>
                    </NavDropdown.Item>
                    <div className='dropdown-divider-custom' />
                    <NavDropdown.Item
                      as={Link}
                      to='/api-docs'
                      className='dropdown-item-card'
                    >
                      <div className='item-wrapper'>
                        <span className='item-icon'>
                          <ApiIcon fontSize='small' />
                        </span>
                        <span className='item-content'>
                          <span className='item-title'>API Services</span>
                          <span className='item-desc'>
                            Secure trading integration
                          </span>
                        </span>
                        <span className='item-arrow'>
                          <ArrowRightOutlinedIcon fontSize='small' />
                        </span>
                      </div>
                    </NavDropdown.Item>
                    <div className='dropdown-divider-custom' />
                    <NavDropdown.Item
                      as={Link}
                      to='/vip-trading'
                      className='dropdown-item-card'
                    >
                      <div className='item-wrapper'>
                        <span className='item-icon'>
                          <WorkspacePremiumIcon fontSize='small' />
                        </span>
                        <span className='item-content'>
                          <span className='item-title'>
                            VIP trading service
                          </span>
                          <span className='item-desc'>
                            Priority support benefits
                          </span>
                        </span>
                        <span className='item-arrow'>
                          <ArrowRightOutlinedIcon fontSize='small' />
                        </span>
                      </div>
                    </NavDropdown.Item>
                    <div className='dropdown-divider-custom' />
                    <NavDropdown.Item
                      as={Link}
                      to='/partnership'
                      className='dropdown-item-card'
                    >
                      <div className='item-wrapper'>
                        <span className='item-icon'>
                          <HandshakeIcon fontSize='small' />
                        </span>
                        <span className='item-content'>
                          <span className='item-title'>Partnership</span>
                          <span className='item-desc'>
                            Business collaboration
                          </span>
                        </span>
                        <span className='item-arrow'>
                          <ArrowRightOutlinedIcon fontSize='small' />
                        </span>
                      </div>
                    </NavDropdown.Item>
                  </div>
                </NavDropdown>

                <Nav.Link as={Link} to='/my/referral'>
                  <span
                    style={{
                      color: pathname.includes('/my/referral') ? '#1DA094' : '',
                    }}
                  >
                    Reward
                  </span>
                </Nav.Link>

                <NavDropdown
                  title={
                    <span
                      className='more-dropdown-title'
                      style={{
                        color:
                          pathname.includes('/blog') ||
                            pathname.includes('/help-center') ||
                            pathname.includes('/help-center')
                            ? '#1DA094'
                            : '',
                      }}
                    >
                      More
                    </span>
                  }
                  id='more-dropdown'
                  align='end'
                  menuVariant='dark'
                  show={openDropdown === 'more'}
                  onToggle={(isOpen) => handleDropdownToggle('more', isOpen)}
                  className={`custom-trade-nav-dropdown ${borderDropdown === 'more' ? 'show-green-border' : ''
                    }`}
                >
                  <div className='dropdown-inner-wrapper' onClick={() => setExpanded(false)}>
                    <NavDropdown.Item
                      as={Link}
                      to='/blog'
                      className='dropdown-item-card'
                    >
                      <div className='item-wrapper'>
                        <span className='item-icon'>
                          <ArticleOutlinedIcon fontSize='small' />
                        </span>
                        <span className='item-content'>
                          <span className='item-title'>Blog</span>
                          <span className='item-desc'>
                            Market insights updates
                          </span>
                        </span>
                        <span className='item-arrow'>
                          <ArrowRightOutlinedIcon fontSize='small' />
                        </span>
                      </div>
                    </NavDropdown.Item>
                    <div className='dropdown-divider-custom' />
                    <NavDropdown.Item
                      as={Link}
                      to='/help-center'
                      className='dropdown-item-card'
                    >
                      <div className='item-wrapper'>
                        <span className='item-icon'>
                          <SupportAgentOutlinedIcon fontSize='small' />
                        </span>
                        <span className='item-content'>
                          <span className='item-title'>Help Center</span>
                          <span className='item-desc'>Guides FAQs support</span>
                        </span>
                        <span className='item-arrow'>
                          <ArrowRightOutlinedIcon fontSize='small' />
                        </span>
                      </div>
                    </NavDropdown.Item>
                    <div className='dropdown-divider-custom' />
                    <NavDropdown.Item
                      as={Link}
                      to='/help-center'
                      className='dropdown-item-card'
                    >
                      <div className='item-wrapper'>
                        <span className='item-icon'>
                          <HeadsetMicOutlinedIcon fontSize='small' />
                        </span>
                        <span className='item-content'>
                          <span className='item-title'>Contact</span>
                          <span className='item-desc'>Support assistance</span>
                        </span>
                        <span className='item-arrow'>
                          <ArrowRightOutlinedIcon fontSize='small' />
                        </span>
                      </div>
                    </NavDropdown.Item>
                  </div>
                </NavDropdown>
                {userLogin ? (
                  <Nav.Link as={Link} to='/my/dashboard'>
                    <span
                      style={{
                        color:
                          pathname.includes('/signal') ||
                            pathname.includes('/my/dashboard')
                            ? '#1DA094'
                            : '',
                      }}
                    >
                      Portfolio
                    </span>
                  </Nav.Link>
                ) : null}
              </Nav>

              <Nav className='align-items-start align-items-lg-center gap-3'>

                {userLogin ? (
                  menuBar
                ) : (
                  <>
                    <Nav.Link
                      as={Link}
                      to='/login'
                      className='text-light fw-semibold text-decoration-none darkNavCss'
                    >
                      Login
                    </Nav.Link>
                    <Button
                      component={Link}
                      to='/register'
                      variant='contained'
                      sx={{
                        bgcolor: '#1DAFA1',
                        color: 'white',
                        borderRadius: '8px',
                        textTransform: 'none',
                        fontWeight: 600,
                        fontSize: '0.9rem',
                        padding: '6px 20px',
                        '&:hover': { bgcolor: '#189a8dff' },
                      }}
                    >
                      Sign Up
                    </Button>
                  </>
                )}
              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
    </div>
  )
}

export default HeaderHome
